import { usePayments } from "../hooks/usePayments";
import PaymentMethodByCustomerForm from "./PaymentMethodByCustomerForm";
import Error from "./Error";
import SharedModal from "./shared/SharedModal";
import { useState } from "react";
import StampedSignatures from "./modals/StampedSignatures";
import { Box } from "@material-ui/core";

export default function PaymentMethodByCustomer({ setCurrentBrand }) {
  const [customerSignature, setCustomerSignature] = useState();
  const [stampedCustomerSignature, setStampedCustomerSignature] =
    useState(null);

  const {
    customerId,
    agreementId,
    customerAgreements,
    bankList,
    status,
    isLoading,
    ip,
  } = usePayments({ setCurrentBrand }); // custom hook

  return (
    <>
      {!isLoading ? (
        <>
          {customerAgreements &&
          Object.keys(customerAgreements).some(
            (key) => key === "cards" || key === "acount_banks"
          ) ? (
            <>
              <Box Box style={{ position: "relative" }}>
                <PaymentMethodByCustomerForm
                  customerId={customerId}
                  agreementId={agreementId}
                  customerAgreements={customerAgreements}
                  bankList={bankList}
                  setCustomerSignature={setCustomerSignature}
                  stampedCustomerSignature={stampedCustomerSignature}
                />
                <Box style={{ position: "absolute", top: 0, left: "-100%" }}>
                  <StampedSignatures
                    setStampedCustomerSignature={setStampedCustomerSignature}
                    stampedCustomerSignature={stampedCustomerSignature}
                    customerSignature={customerSignature}
                    ip={ip}
                  />
                </Box>
              </Box>
            </>
          ) : (
            <Error
              customTitle={"NO ES POSIBLE AGREGAR MÉTODO DE PAGOS"}
              // ! corregir, se debe cambair el bad request de backed hacer set de status
              customMessage={"VERIFIQUE LOS DATOS"}
              errorCollection={status ? status : []}
            />
          )}
        </>
      ) : (
        <Error hasLoader />
      )}
    </>
  );
}
